import styled from "styled-components";

export const BottomText = styled.div`
  margin-right: 12px;
  font-size: 16px;
  font-weight: 400;
  color: #342309;
  text-align: right;
  margin-top: 8px;

  span {
    cursor: pointer;
  }
`;
